import React, { useState } from 'react';
import axios from 'axios';

const SaisieCourrier = () => {
    const [formData, setFormData] = useState({
        num_ordre: '',
        date_reception: '',
        reference: '',
        expediteur: '',
        objet: '',
        categorie: 'EXTERNE',
        flux: 'ENTRANT',
        is_urgent: false,
        orientation_id: '2' // ID du DG par défaut dans votre table users
    });
    const [file, setFile] = useState(null);
    const [status, setStatus] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('Envoi en cours...');
        
        const data = new FormData();
        Object.keys(formData).forEach(key => data.append(key, formData[key]));
        if (file) data.append('scan', file);
        data.append('created_by', '2'); // ID de l'admin pour le test

        try {
            const response = await axios.post('https://courriers.oscep.cd/ajouter_courrier.php', data);
            if(response.data.success) {
                setStatus('✅ Courrier enregistré ! Le badge du DG est activé.');
                e.target.reset();
            } else {
                setStatus('❌ Erreur : ' + response.data.message);
            }
        } catch (error) {
            setStatus('❌ Erreur de connexion au serveur.');
            console.error(error);
        }
    };

    return (
        <div style={{ padding: '30px', maxWidth: '500px', margin: 'auto', textAlign: 'left' }}>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <input type="text" placeholder="N° d'ordre" required onChange={(e) => setFormData({...formData, num_ordre: e.target.value})} />
                <input type="date" required onChange={(e) => setFormData({...formData, date_reception: e.target.value})} />
                <input type="text" placeholder="Référence Externe" onChange={(e) => setFormData({...formData, reference: e.target.value})} />
                <input type="text" placeholder="Expéditeur" onChange={(e) => setFormData({...formData, expediteur: e.target.value})} />
                <textarea placeholder="Objet du courrier" rows="4" onChange={(e) => setFormData({...formData, objet: e.target.value})} />
                
                <label style={{ fontWeight: 'bold', color: 'red' }}>
                    <input type="checkbox" onChange={(e) => setFormData({...formData, is_urgent: e.target.checked})} />
                    🚨 MARQUER COMME URGENT (Vibration)
                </label>
                
                <label>Scan du courrier (PDF ou Image) :</label>
                <input type="file" accept="application/pdf,image/*" onChange={(e) => setFile(e.target.files[0])} />
                
                <button type="submit" style={{ padding: '15px', backgroundColor: '#007bff', color: 'white', border: 'none', cursor: 'pointer' }}>
                    ENREGISTRER LE COURRIER
                </button>
            </form>
            {status && <p style={{ marginTop: '20px', fontWeight: 'bold' }}>{status}</p>}
        </div>
    );
};

export default SaisieCourrier;